import { render, staticRenderFns } from "./SeminarEntryDetail.vue?vue&type=template&id=31082ff2&scoped=true"
import script from "./SeminarEntryDetail.vue?vue&type=script&lang=js"
export * from "./SeminarEntryDetail.vue?vue&type=script&lang=js"
import style0 from "./SeminarEntryDetail.vue?vue&type=style&index=0&id=31082ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31082ff2",
  null
  
)

export default component.exports